import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable()
export class SettingsHubService extends HubService {
  constructor() {
    super(`${environment.settings.api}/hubs/settings`);
  }
}
